import { formatCurrency, formatNumber } from '../../../../utils/helper';
import { Box } from '@mui/material';
import CustomTable from '../../../CustomTable';
interface IProps {
    loadingData?: boolean;
    data?: any;
}

const MobileItemsCards = ({ item }: { item?: any }) => {
    return (
        <>
            <Box key={item?.id} borderBottom='1px solid#EAECF0' p={3}>
                <Box width='full' justifyContent='space-between' display='flex'>
                    <Box display='flex' gap={1}>
                        <Box>
                            <h4 className=' text-ebony text-[14px] font-semibold'>
                                Product Code: {item?.productCode ?? '--'}
                            </h4>
                            <p className=' text-[12px] text-paleSky whitespace-pre-line max-w-[320px] overflow-hidden'>
                                Description:
                                <span className=' pl-1 pr-3 font-extrabold'>
                                    {item?.descriptionOfGoods ?? '--'}
                                </span>
                            </p>
                            <p className=' text-[12px] text-paleSky'>
                                Qty:
                                <span className=' pl-1 pr-3 font-extrabold'>
                                    {formatNumber(item?.quantity ?? 0)}
                                </span>
                                Unit Type:
                                <span className=' pl-1 pr-3 font-extrabold capitalize'>
                                    {item?.unitType ?? 0}
                                </span>
                                Unit Price:
                                <span className=' pl-1 pr-3 font-extrabold capitalize'>
                                    {formatCurrency(
                                        item?.unitPrice ?? 0,
                                        item.currencyCode
                                    )}
                                </span>
                            </p>
                            <p className=' text-[12px] text-paleSky'>
                                Total Amount:
                                <span className=' pl-1 pr-3 font-extrabold capitalize'>
                                    {formatCurrency(
                                        item?.unitPrice * item?.quantity || 0,
                                        item?.currencyCode || 'NGN'
                                    )}
                                </span>
                            </p>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    );
};

const InvoiceItemsTable = ({ loadingData, data }: IProps) => {
    return (
        <CustomTable
            data={data?.items ?? []}
            loadingData={loadingData}
            emptyText='You have no Items on this Invoice.'
            mobileComponent={<MobileItemsCards />}
            columns={[
                {
                    title: 'Product Code',
                    dataIndex: 'productCode',
                    key: 'productCode',
                    render: (text) => <span>{text}</span>
                },
                {
                    title: 'Description',
                    dataIndex: 'descriptionOfGoods',
                    key: 'descriptionOfGoods',
                    render: (text) => <span>{text}</span>
                },
                {
                    title: 'Quantity',
                    dataIndex: 'quantity',
                    key: 'quantity',
                    render: (text) => <span>{formatNumber(text || 0)}</span>
                },
                {
                    title: 'Unit Type',
                    dataIndex: 'unitType',
                    key: 'unitType'
                },
                {
                    title: 'Unit Price',
                    dataIndex: 'unitPrice',
                    key: 'unitPrice',
                    render: (text) => (
                        <span>
                            {formatCurrency(text || 0, data.currencyCode)}
                        </span>
                    )
                },

                {
                    title: 'Total Amount',
                    dataIndex: 'amount',
                    key: 'amount',
                    render: (_, record: any) => (
                        <span>
                            {formatCurrency(
                                record?.unitPrice * record?.quantity || 0,
                                data?.currencyCode || 'NGN'
                            )}
                        </span>
                    )
                }
            ]}
        />
    );
};

export default InvoiceItemsTable;
